<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <fuse-sidebar class="sidebar" name="public-api-access-list-sidebar" position="left" lockedOpen="gt-md">
        <public-api-access-list-sidebar></public-api-access-list-sidebar>
    </fuse-sidebar>

    <div class="center">

        <div class="content-card" style="overflow-y: scroll;">
            <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
                <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
                      fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

                    <div class="h2 mb-24">{{'Public API access data'|translate}}</div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Name'|translate}}</mat-label>
                            <input matInput formControlName="name" required>
                            <mat-error>{{'Name is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                            <mat-label>{{'Access key'|translate}}</mat-label>
                            <input matInput formControlName="accessKey" required>
                            <mat-error>{{'Access key is required!'|translate}}</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <button mat-raised-button type="submit" color="accent">
                                {{'Save'|translate}}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>